import { render, staticRenderFns } from "./quizModulePageNew1.vue?vue&type=template&id=5ebaf7da&scoped=true&"
import script from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
export * from "./quizModulePageNew1.vue?vue&type=script&lang=js&"
import style0 from "./quizModulePageNew1.vue?vue&type=style&index=0&id=5ebaf7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebaf7da",
  null
  
)

export default component.exports